import { AdScanningFinishedNotification } from '../domain';

export function getAdScanningFinishedTitle(
  _notification: AdScanningFinishedNotification
): string {
  return 'Malware scan finished';
}
